import { useState, useEffect, useRef } from 'react'

const POLL_INTERVAL_MS = 30_000

export function useVersionCheck(): { hasNewVersion: boolean; dismiss: () => void } {
  const [hasNewVersion, setHasNewVersion] = useState(false)
  const initialVersion = useRef<string | null>(null)
  const dismissed = useRef(false)

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/version')
        const version = await response.text()

        if (initialVersion.current === null) {
          initialVersion.current = version
          return
        }

        if (version !== initialVersion.current && !dismissed.current) {
          setHasNewVersion(true)
        }
      } catch {
        // Network error - silently ignore, retry next interval
      }
    }

    checkVersion()
    const interval = setInterval(checkVersion, POLL_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [])

  const dismiss = () => {
    dismissed.current = true
    setHasNewVersion(false)
  }

  return { hasNewVersion, dismiss }
}
